import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'
import { ApiService } from 'src/app/services/api.service'
import { UiService } from 'src/app/services/ui.service'
import { handleArpioError } from 'src/utils/handle-error'

@Component({
  selector: 'app-auth-finish-invite',
  templateUrl: './auth-finish-invite.component.html',
  styleUrls: ['./auth-finish-invite.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AuthFinishInviteComponent implements OnInit {
  constructor(
    private apiService: ApiService,
    private uiService: UiService,
    private router: Router
  ) {}

  ngOnInit() {
    this.apiService.listAccounts().subscribe(
      (accounts) => {
        // If the user only has access to one account, we take them to the welcome page there.
        // Otherwise, we take them to the root of the app where they'll need top pick the
        // account they care about.
        if (accounts.length == 1) {
          let welcomeUrl = this.uiService.buildAccountWelcomeUrl(accounts[0].accountId)
          this.router.navigateByUrl(welcomeUrl)
        } else {
          this.router.navigateByUrl('/')
        }
      },
      handleArpioError(window.location.href, this.apiService, this.uiService)
    )
  }
}
